import { useState } from "react";

const Contact = () => {
  const [details, setDetails] = useState({
    email: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const { email } = details;

    const res = await fetch("https://email-ea843-default-rtdb.europe-west1.firebasedatabase.app/simpleform.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });

    setIsLoading(false);
    setIsSuccess(true);
    setDetails({ email: "" });

    setTimeout(() => {
      setIsSuccess(false);
    }, 3000);
  };

  return (
    <div className="contact-page-wrapper">
      <h1 className="primary-heading">Would you like to subscribe to our newsletter? </h1>
      <p className="primary-subheading">Please provide your email address and keep informed about our latest releases</p>
      <div>
        <form onSubmit={handleSubmit} className="contact-form-container">
          <input
            type="email"
            placeholder="yourmail@gmail.com"
            value={details.email}
            onChange={(e) => setDetails({ email: e.target.value })}
            required
          />
          <button type="submit" className="secondary-button">
            {isLoading ? "Submiting..." : "Submit"}
          </button>
        </form>
        <div className="message-container">
        {isSuccess && (
          <p style={{ color: "green", alignItems: "center" }}>Your email was sent!</p>
        )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
